import * as React from 'react';
import { StripCard } from 'wix-ui-tpa/StripCard';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { Button } from 'wix-ui-tpa/Button';
import { ApiTypes } from '@wix/social-groups-api';
import { GroupLogoPlaceholderIconWide } from '../icons/GroupLogoPlaceholderWide';

import styles from './GroupListItem.st.css';

const PRIVACY_LEVEL_MAP = {
  [ApiTypes.v1.GroupPrivacyLevel.PUBLIC]:
    'groups-web.group-list.privacy.public',
  [ApiTypes.v1.GroupPrivacyLevel.PRIVATE]:
    'groups-web.group-list.privacy.private',
  [ApiTypes.v1.GroupPrivacyLevel.SECRET]:
    'groups-web.group-list.privacy.secret',
};

export interface GroupListItemProps {
  group: ApiTypes.v1.GroupResponse;
  openGroup(groupId: string): void;
}

export const GroupListItemComponent: React.FC<
  GroupListItemProps & InjectedTranslateProps
> = props => {
  const { group, goToGroup, t, ...restProps } = props;

  const logoStyle: React.CSSProperties = {};

  if (group.details.logoUrl) {
    logoStyle.backgroundImage = `url(${group.details.logoUrl})`;
  }

  return (
    <StripCard
      media={
        <div className={styles.groupImage} style={logoStyle}>
          {group.details.logoUrl ? null : <GroupLogoPlaceholderIconWide />}
        </div>
      }
      info={
        <>
          <div className={styles.groupInfo}>
            <Text
              tagName="div"
              typography={TYPOGRAPHY.smallTitle}
              {...styles(styles.groupName)}
            >
              {group.details.title}
            </Text>
            <Text typography={TYPOGRAPHY.listText}>
              {t(PRIVACY_LEVEL_MAP[group.settings.privacyLevel])}
            </Text>
          </div>
          <div className={styles.membersInfo}>
            {group.memberCount} member
            {/* TODO: clarify about members */}
          </div>
          <Button
            className={styles.actionButton}
            onClick={() => goToGroup(group.groupId)}
          >
            {t('groups-web.btn.view-group')}
          </Button>
        </>
      }
      {...styles(styles.root, {}, restProps)}
    />
  );
};

export const GroupListItem = translate()(GroupListItemComponent);
